import React from 'react';
import "./careers.css"
import diamond from "../../assets/diamond.svg"
import careerim from "../../assets/careerim.png"
import culture from "../../assets/culture.png"
import branding from "../../assets/branding.png"
import marketing from "../../assets/marketing.png"
import recruiting from "../../assets/recruiting.png"
import designers from "../../assets/designers.png"
import developers from "../../assets/developers.png"
import senior from "../../assets/senior.png"
import seniorgraphic from "../../assets/seniorgraphic.png"
import perks from "../../assets/perks.svg"
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
 import { Helmet } from 'react-helmet'; // Uncomment if you want to use Helmet for SEO
import { Link } from 'react-router-dom'; // Uncomment if you want to use Link
const Careers = () => {
  return (
    <>
    
     <Helmet>
      <title>Careers | Vasmi Group</title>
    </Helmet>

        <div className='career'>
      <img src={careerim} alt='doom' className='career-land' />

      {/* <div className='sde-sec-one'>
        <div className='sde-sec-one-left'>
          <p className='sde-sec-left-heading career-plus'>
            <strong>
              Our Culture
            </strong>

          </p>
          <p className='sde-sec-one-para'>
            At Vasmi Group, our culture thrives on innovation, collaboration, and relentless passion for digital  excellence. We cultivate an environment where creativity flourishes, ideas converge, and each team  member plays a vital role in our success story. Our collaborative spirit extends beyond projects,  fostering a supportive community that encourages continuous learning and growth. Embracing  diversity and inclusivity, we celebrate each milestone, creating a culture that not only drives  exceptional digital marketing results but also nurtures a fulfilling and inspiring workplace for  everyone involved in our journey.

          </p>

          <button className='sde-sec-one-btn btn-career'>
            For Candidates

          </button>
        </div>
        <img src={culture} alt='sde' className='career-soft' />
      </div> */}
      <div>
        {/* <p className='about-sec-two-head'>
      The type of Innovators we look for
      </p> */}
        {/* <div className='brands-career'>

         
          <img src={developers} alt='brand'/>
         
          <img src={marketing} alt='brand'/>
          <img src={designers} alt='brand'/>
        </div> */}
      </div>





      {/* <div className='position-vision'>
        <div className='position-cover cover-flow'>

          <p className='perk-para'>Our Vision</p>

          <p className='perk-para-career'>At Vasmi Group, our vision is to be the architects of digital success, seamlessly blending innovation,  strategy, and expertise. We aspire to redefine business excellence by offering comprehensive digital  marketing, website development, and recruitment services. Our mission is to empower brands with a  dynamic online presence, crafted through cutting-edge websites and fuelled by strategic digital  marketing campaigns. We envision not just fulfilling but exceeding our client's expectations, creating  an ecosystem where businesses thrive, websites resonate, and teams flourish. Join us in navigating  the digital landscape, where success is not just a destination but a continuous, evolving journey.

          </p>
        </div>
        <div className='position-cover cover-flow'>

          <p className='perk-para'>Our Mission</p>

          <p className='perk-para-career'>At Vasmi Group, our mission is to catalyze your digital ascendancy through an integrated approach of  unparalleled digital marketing, bespoke website development, and strategic recruitment services.  We are committed to fostering your brand's online resonance, leveraging cutting-edge technologies  and innovative strategies. Our dedicated team strives to empower businesses with impactful digital  solutions, ensuring your digital footprint transcends expectations. Through adept website  development and astute recruitment, we aim to build not just brands, but sustainable ecosystems of  success.

          </p>
        </div>

      </div> */}

      <div className="form-recruit-r">
        <p className="platform-heading-r">Keen to work with Vasmi Group?</p>

        {/* Flex container for both forms */}
       <div className="forms-flex-container">

          {/* First Form */}
          <div className="recruit-formm" style={{ flex: "1 1 400px", maxWidth: "500px" }}>
            <p className="submit-recruit-p">Submit your CV</p>
            <form action="">
              <div className="form-inps-recruit">
                <input type="text" placeholder="FirstName" />
                <input type="text" placeholder="LastName" />
                <input type="email" required placeholder="Email" />
                <input type="text" placeholder="PhoneNumber" />
                <input type="text" placeholder="Nationality" />
                <select name="select" id="">
                  <option value="Primary Role Interested in">Primary Role Interested in</option>
                  <option value="Frontend Developer">Frontend Developer</option>
                  <option value="Full Stack Developer">Full Stack Developer</option>
                </select>
                <input type="text" placeholder="Years Of Experience" />
                <input
                  style={{ border: "none" }}
                  type="file"
                  name="d"
                  id="down"
                  placeholder="upload Your Cv"
                />
              </div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 28,
                          "& .css-1ikz1rn-MuiButtonBase-root-MuiCheckbox-root.Mui-checked": {
                            color: "white",
                          },
                        },
                      }}
                    />
                  }
                  label="I consent to Handmade contacting me via the information that I have provided."
                  sx={{
                    "& .css-ahj2mt-MuiTypography-root": {
                      fontSize: 14,
                      width: "300px",
                      color: "black",
                    },
                  }}
                />
              </FormGroup>
              <button className="contact-btn r-btn">Submit</button>
            </form>
          </div>

          {/* Second Form */}
          {/* <div className="internship-form-container">
            <h2 className="form-title">Internship Application Form</h2>
            <form className="internship-form">
              <div className="form-row">
                <input type="text" name="name" placeholder="Full Name" required />
                <input type="email" name="email" placeholder="Email Address" required />
              </div>
              <div className="form-row">
                <input type="tel" name="phone" placeholder="Phone Number" required />
                <input type="text" name="college" placeholder="College Name" />
              </div>
              <div className="form-row">
                <input type="text" name="degree" placeholder="Degree / Major" />
                <input type="text" name="experience" placeholder="Years of Experience" />
              </div>
              <div className="form-row">
                <textarea name="skills" placeholder="Skills (e.g., Java, React)" rows="3"></textarea>
                <input type="file" name="resume" />
              </div>
              <div className="form-checkbox">
                <input type="checkbox" name="consent" id="consent" />
                <label htmlFor="consent">I consent to being contacted via the information provided.</label>
              </div>
              <div className="form-submit">
                <button type="submit">Submit Application</button>
              </div>
            </form>
          </div> */}

        </div>
      </div>


    </div>
    </>
  );
}

export default Careers;
